var map = {
	"./jw_black.jpg": 715,
	"./jw_double_black.jpg": 716,
	"./jw_gold.jpg": 717,
	"./jw_green.jpg": 718,
	"./jw_platinum.jpg": 719,
	"./jw_red.jpg": 720
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 714;


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/General nonrecursive \.(png|jpe?g|svg)$
// module id = 714
// module chunks = 0